import { App } from 'vue'
import Catalog from './Catalog.vue'
import CatalogDetails from './CatalogDetails.vue'

const register = (app: App<Element>): void => {
  app
    .component('product-category-catalog', Catalog)
    .component('product-category-details-catalog', CatalogDetails)
}

export default {
  register,
}
